import React from 'react';
import {Platform, StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import {Picker as RNPicker} from '@react-native-picker/picker';

import {indent} from '/constant/layout.constant';
import {Shared} from '/constant/TestIDs';
import {cloudLighter, denim, onyx, white} from '/theme/color/on.color';

import {CustomPickerProps} from './Picker.types';

export const Picker: React.FC<CustomPickerProps> = ({
  items = [],
  selectedItem = 0,
  setSelectedItem = () => {},
}) => {
  const onValueChange = (itemValue: any) => {
    setSelectedItem(itemValue);
  };

  if (Platform.OS === 'web') {
    return (
      <View style={styles.webContainer}>
        {items.map((item: any, index: any) => (
          <TouchableOpacity
            key={item}
            onPress={() => setSelectedItem(index)}
            style={[
              styles.webItem,
              selectedItem === index && styles.webItemSelected,
            ]}>
            <Text
              style={[
                styles.webItemText,
                selectedItem === index && styles.webItemTextSelected,
              ]}>
              {item}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    );
  }

  return (
    <RNPicker
      selectedValue={selectedItem}
      onValueChange={onValueChange}
      testID={Shared.datePicker}>
      {items.map((item: any, index: any) => (
        <RNPicker.Item key={item} label={item} value={index} />
      ))}
    </RNPicker>
  );
};

const styles = StyleSheet.create({
  webContainer: {
    paddingVertical: indent,
  },
  webItem: {
    paddingVertical: indent,
    paddingHorizontal: indent * 1.5,
    borderBottomWidth: 1,
    borderBottomColor: cloudLighter,
    backgroundColor: white,
    alignItems: 'center',
    ...(Platform.OS === 'web' && {cursor: 'pointer'}),
  },
  webItemSelected: {
    backgroundColor: cloudLighter,
  },
  webItemText: {
    fontSize: 16,
    color: onyx,
    textAlign: 'center',
  },
  webItemTextSelected: {
    color: denim,
    fontWeight: '600',
  },
});
